import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import HSButtonUI from './hsbuttonui';
import HSButtonEditing from './hsbuttonediting';

export default class HSButton extends Plugin {
    static get requires() {
        return [ HSButtonEditing, HSButtonUI ];
    }
}